/** Selector for any instance of this _Friendation_ component */
const selector = '[is="basis-job-teaser"]';

/**
 * Friendation component
 */
export const basisJobTeaser = () => {
  /** Instances of this Friendation component */
  const components: HTMLElement[] = Array.from(
    document.querySelectorAll(selector)
  );

  components.forEach((component) => {
    /** The theme changes on hover/focus */
    const handleThemeToggle = () => {
      const link: HTMLAnchorElement =
        component.querySelector('.cta > a.button');

      const toggleStyles = (add: boolean) => {
        component.classList.toggle('backgroundThree', add);
        component.classList.toggle('backgroundTwo', !add);
      };

      link.addEventListener('mouseenter', () => toggleStyles(true));
      link.addEventListener('mouseleave', () => toggleStyles(false));
      link.addEventListener('focus', () => toggleStyles(true));
      link.addEventListener('blur', () => toggleStyles(false));
    };

    handleThemeToggle();
  });
};
